// order is important
export const accountantTypes = [
  'bookkeeper',
  'accountant',
  'accountant_hdr',
  'approved_accountant',
  'chartered_accountant',
] as const
